import React, { useEffect, useState } from 'react';
import logo from '../assets/soil-doctor-logo.png';
import { getTranslation } from '../translations';
import { getPartnerLogoPresentation, usePartnerLogoAspect } from '../../../utils/partnerLogoDisplay';

export default function ReportHeader({
  association,
  language = 'english',
  partnerLogoUrl,
}) {
  const t = getTranslation(language);
  const [src, setSrc] = useState(partnerLogoUrl || logo);

  useEffect(() => {
    setSrc(partnerLogoUrl || logo);
  }, [partnerLogoUrl]);

  const handleError = () => {
    if (src !== logo) {
      setSrc(logo);
    }
  };

  const isPartnerProfile = Boolean(partnerLogoUrl) && src === partnerLogoUrl;
  const displayName = isPartnerProfile && association ? association : 'Soil Doctor';
  const displayLogo = src;

  const { isBanner, onImageLoad } = usePartnerLogoAspect(isPartnerProfile ? partnerLogoUrl : null);
  const logoPresentation = getPartnerLogoPresentation(isPartnerProfile && isBanner, 'report');

  return (
    <div className="w-full">
      <div className="bg-[#123e28] text-white px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img
            src={displayLogo}
            alt={displayName}
            onLoad={onImageLoad}
            onError={handleError}
            className={logoPresentation.className}
            style={logoPresentation.style}
          />
          <span className="text-2xl font-semibold pt-2 pb-2">{displayName}</span>

        </div>
        {association && !isPartnerProfile && (
          <div className="flex flex-col items-end text-right">
            <span className="italic opacity-90 text-sm">
              {t.inAssociationWith}
            </span>
            <span className="text-2xl font-semibold">
              {association}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
